'use strict'

const selectionTrigger = document.querySelector('.search .selection-expanded');
const selection = document.querySelector('section.selection');

const scrollTo = element => {
    let top = element.getBoundingClientRect().top;
    window.scrollTo({
        top: top,
        behavior: 'smooth'
    });
}

const setSelection = e => {
    e.preventDefault();
    selection.classList.toggle('active');
    if(selection.classList.contains('active'))
    {
        scrollTo(selection);
    }

}

export default _ => {
    if(selectionTrigger)
        selectionTrigger.addEventListener('click', setSelection);
}
